module.exports = __webpack_public_path__ + "static/Educollect-logo-9efd8eb16fc161f063d860ed3e4aada0.png";